module.exports = __webpack_public_path__ + "img/pallet-tracking.883d6ddd.svg";